import React, { useState, useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import chatbotIcon from "./assets/chatIcon.png";
import half_logo from "./assets/half_logo.png";
import "./css/chatbotStyle.css";

const ChatbotIcon = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: `Hello, Welcome to Malawi Bureau of Standards! How can we help you today?`,
    },
  ]);
  const [isTyping, setIsTyping] = useState(false);
  const [showAllHelpers, setShowAllHelpers] = useState(false);
  const messagesEndRef = useRef(null);

  const toggleChat = () => setIsChatOpen(!isChatOpen);
  const toggleHelperList = () => setShowAllHelpers(!showAllHelpers);

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    setMessages((prev) => [...prev, { sender: "user", text: userInput }]);
    setUserInput("");
    setIsTyping(true);

    try {
      const response = await fetch("http://192.168.24.142:6500/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userInput }),
      });

      const data = await response.json();

      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: data.response || "Sorry, something went wrong.",
          },
        ]);
        setIsTyping(false);
      }, 1000);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "Sorry, something went wrong. Please try again later.",
        },
      ]);
      setIsTyping(false);
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // ===================
  // Helper Questions
  // ===================
  const helperQuestions = [
    "What is the Malawi Bureau of Standards?",
    "Where is the MBS headquarters?",
    "What does the Standards Development Department do?",
    "How can I get a copy of a Malawi Standard?",
    "How is a standard developed?",
    "What does the Quality Assurance Services Department do?",
    "How can I get a product certified by MBS?",
    "Why is product certification important?",
    "How can I get my restaurant or hotel designated?",
    "How often does MBS conduct inspections?",
    "Tell me about the Testing Department",
    "How can I submit a sample for testing?",
    "How long do test results take?",
    "What does the Metrology Department do?",
    "Do you offer calibration services?",
    "What is verification of instruments?",
    "What is a Licence of Competency?",
    "What does the Finance Department do?",
    "What does the HR Department do?",
    "What are the penalties for non-compliance?",
    "How can I report a substandard product?",
    "How can I contact MBS?",
    "What is your phone number?",
    "Do you have an email address?",
    "Where can I lodge a complaint?",
    "Can I report fake goods to MBS?",
    "What happens if I fail to meet standards?",
    "Can MBS revoke my certificate?",
    "Who handles employment at MBS?",
    "How can I apply for a job at MBS?",
    "Who manages finances at MBS?",
    "How do I pay for MBS services?",
    "How do I get a Licence of Competency?",
    "Who can repair weighing machines?",
    "Do you verify weighing scales?",
    "How often should I verify my scale?",
    "Can you calibrate weighing scales?",
    "Where can I calibrate instruments?",
    "Tell me about metrology at MBS",
    "What is legal metrology?",
    "When will I get my test report?",
    "Can I get test results electronically?",
    "Where do I take my product for testing?",
    "Can the public request testing?",
    "Tell me about the Testing Department",
    "Does MBS have a lab?",
    "When are inspections done?",
    "Does MBS inspect all products?",
    "How can I get my restaurant or hotel designated?",
    "What does it mean to be designated by MBS?",
    "Why should I certify my product?",
    "Steps for product certification",
    "How do I apply for certification?",
    "Tell me about Quality Assurance at MBS",
    "What is quality assurance?",
    "Who decides on Malawi Standards?",
    "What is the process for developing standards?",
    "Where can I find Malawi Standards?",
    "Can I buy standards from MBS?",
    "Tell me about the Standards Development Department",
    "Who develops standards at MBS?",
    "Where are you located?",
    "Where is your office located?",
    "What is your address?"
  ];

  const displayedHelpers = showAllHelpers ? helperQuestions : helperQuestions.slice(0, 5);

  return (
    <>
      {/* Floating Chat Icon */}
      <div className="chatbot-icon" onClick={toggleChat}>
        <img src={chatbotIcon} alt="Chatbot Icon" width="40" height="40" />
      </div>

      {/* Chat Interface */}
      {isChatOpen && (
        <div className="chatbot-interface">
          <div className="chatbot-header">
            <div className="header-left">
              <img src={half_logo} alt="MBS Logo" className="header-logo" />
              <div className="header-title">
                <h4>MBS Chatbot</h4>
                <div className="online-status">
                  <span className="status-dot"></span>
                  <span>Online</span>
                </div>
              </div>
            </div>
            <button className="close-button" onClick={toggleChat}>
              <span className="close-icon">×</span>
            </button>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div key={index} className={`chatbot-message-wrapper ${msg.sender}`}>
                {msg.sender === "bot" && (
                  <img src={half_logo} alt="MBS Profile" className="bot-profile-image" />
                )}

                <div className={`chatbot-message ${msg.sender}`}>
                  {index === 0 && msg.sender === "bot" ? (
                    <>
                      <p><strong>Hello, Welcome to Malawi Bureau of Standards!</strong></p>
                      <p>How can we help you today?</p>
                      <div className="helper-container">
                        {/* <p>Try asking:</p>
                        <ul className="helper-list">
                          {displayedHelpers.map((q, i) => (
                            <li key={i}>{q}</li>
                          ))}
                        </ul>
                        <button className="read-more-btn" onClick={toggleHelperList}>
                          {showAllHelpers ? "Show Less ▲" : "Read More ▼"}
                        </button> */}
                      </div>
                    </>
                  ) : (
                    msg.text
                  )}
                </div>

                {msg.sender === "user" && <FaUserCircle className="user-profile-icon" />}
              </div>
            ))}

            {isTyping && (
              <div className="typing-indicator">
                MBS is typing
                <div className="typing-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Type a message..."
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatbotIcon;
